<!-- Created by init-app.js at Tue Mar 10 2020 16:02:41 GMT+0100 (GMT+01:00) -->
<template>
  <wgu-app-tpl>
    <!-- insert your app slots here  -->
  </wgu-app-tpl>
</template>

<script>
  import WguAppTemplate from './WguAppTemplate.vue';
  export default {
    name: 'my-wgu-app',
    components: {
      'wgu-app-tpl': WguAppTemplate
    }
    // add Vue methods and hooks here
  }
</script>

<style>
::-webkit-scrollbar {
width: 5px;
height: 15px;
}
::-webkit-scrollbar-track-piece  {
background-color: #C2D2E4;
}
::-webkit-scrollbar-thumb:vertical {
height: 30px;
background-color: #0A4C95;
-webkit-border-radius: 1ex;
}
</style>



// WEBPACK FOOTER //
// app/WguApp.vue